import React from 'react';
import { connect } from 'react-redux';

import ListPage from '@/src/shared/components/ListPage';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';

const RiskBasedPricingLawsAndRegulations = () => {
  const [loading, results] = useListSearch({
    pubCode: 846,
    yearsBack: 5,
    sortField: 'state',
  });

  return (
    <ListPage
      title="Risk-Based Pricing Laws and Regulations"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      loading={loading}
    />
  );
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(
    RiskBasedPricingLawsAndRegulations,
    COMPLIANCE_ACCESS.COMPLIANCE_RESOURCES
  )
);
